import { style } from '@vanilla-extract/css';

export const tableContainer = style({
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: 'var(--wt-table-padding-top)',
  paddingBottom: 'var(--wt-table-padding-bottom)',
});

export const table = style({
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed',
});
